import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09b56fc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "runner" }
const _hoisted_2 = { class: "stage-settings" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "gui" }

import { RunnerComponent } from "@/utils/matter";
import { computed, onUnmounted, toRefs } from "vue";
import { useStore } from "../store";
import BlueLightSwitchVue from "./on-runner/BlueLightSwitch.vue";
import RedLightSwitchVue from "./on-runner/RedLightSwitch.vue";
import DrugAVue from "./on-runner/DrugA.vue";
import BlueLightVue from "./on-runner/BlueLight.vue";
import RedLightVue from "./on-runner/RedLight.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const { registerOutput, UnregisterOutput } = store;
const { proteins, runnerOutputs } = toRefs(store);

const defaultStageSettings: Record<string, RunnerComponent> = {
  [BlueLightVue.name]: BlueLightVue,
  [RedLightVue.name]: RedLightVue,
};
const defaultGUIViews: Record<string, RunnerComponent> = {
  [DrugAVue.name]: DrugAVue,
  [BlueLightSwitchVue.name]: BlueLightSwitchVue,
  [RedLightSwitchVue.name]: RedLightSwitchVue,
};

const stageSettings = computed(() => {
  const _stageSettings: Record<string, RunnerComponent> = Object.assign(
    {},
    defaultStageSettings
  );
  for (const protein of proteins.value) {
    for (const stageSetting of protein.stageSettings) {
      if (!_stageSettings[stageSetting.name]) {
        _stageSettings[stageSetting.name] = stageSetting;
      }
    }
  }
  return Object.values(_stageSettings);
});
const guiViews = computed(() => {
  const _guiViews: Record<string, RunnerComponent> = Object.assign(
    {},
    defaultGUIViews
  );
  for (const protein of proteins.value) {
    for (const guiView of protein.guiViews) {
      if (!_guiViews[guiView.name]) {
        _guiViews[guiView.name] = guiView;
      }
    }
  }
  return Object.values(_guiViews);
});

registerOutput("kill");
onUnmounted(() => {
  UnregisterOutput("kill");
});

const genomyImg = computed(() =>
  runnerOutputs.value["kill"] === 1
    ? "/runner/killed-bacterium.svg"
    : "/runner/bacterium.svg"
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stageSettings), (setting, index) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(setting), { key: index }))
      }), 128))
    ]),
    _createElementVNode("img", {
      src: _unref(genomyImg),
      class: "bacterium"
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(guiViews), (guiView, index) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(guiView), { key: index }))
      }), 128))
    ])
  ]))
}
}

})